<template>
  <div>
    <div class="mb5">
      <span class="checkbox mr30">
        <input type="checkbox" id="check_all" @change="checkAll">
        <label for="check_all">{{locale.all}}</label>
      </span>
      <span v-if="checked.length > 0" class="mr5">
        {{locale.select}} {{checked.length}} / {{list.length}}
      </span>
      <button type="button" class="btn sizeXs" :disabled="disabledDelete" @click="delItems">{{locale.delete}}</button>
    </div>
    <div class="masorny">
      <button type="button" class="btnAdd card" @click="newItem">+</button>
      <div
        v-for="item of list"
        :key="item.id"
        class="card"
         @click="setEdit(item.id, true)">
        <div v-if="item.img" class="thumb"><img :src="item.img" alt="" ></div>
        <div class="content">
          <span class="name">{{item.name}}</span>
          <div class="text mt10" v-html="item.text[lang.default]"></div>
        </div>
        <div class="checkbox chkItem">
          <input type="checkbox" :id="`check_${item.id}`" :value="item.id" v-model="checked" @click.stop />
          <label :for="`check_${item.id}`" @click.stop><span class="blind">{{locale.state_public}}</span></label>
        </div>
      </div>
      <Edit
        v-if="activeItem"
        :locale="locale"
        :lang="lang"
        :item="activeItem"
        @apply="apply"
        @cancel="setEdit(activeItem, false)" />
    </div>
  </div>
</template>

<script>
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import Edit from '@/components/Talk/CardEdit'

export default {
  name: 'Card',
  props: [
    'locale',
    'lang',
    'card'
  ],
  components: {
    Edit
  },
  computed: {
    list () {
      return this.card.list
    },
    disabledDelete () {
      return this.checked.length === 0
    }
  },
  data () {
    return {
      activeItem: null,
      cardItem: {
        id: '',
        name: 'New Card',
        text: {},
        img: '',
        linkActive: false,
        link: {
          type: 'outlink',
          url: this.$store.getters['setting/getLangValues'](),
          pageId: '', // 링크 기본값
          productId: '',
          target: false
        }
      },
      checked: []
    }
  },
  methods: {
    newItem () {
      const item = this._.cloneDeep(this.cardItem)
      item.id = UNIQUE.mid()
      item.text = this.$store.getters['setting/getLangValues']()
      this.$emit('add', {
        target: 'card',
        data: item
      })
    },
    checkAll (e) {
      const isChecked = e.target.checked
      this.checked = isChecked ? this.list.map(x => x.id) : []
    },
    setEdit (id, isActive) {
      this.activeItem = isActive ? this.list.find(x => x.id === id) : null
    },
    delItems () {
      const data = {
        target: 'card',
        ids: this.checked
      }
      if (window.confirm(this.locale.confirm_delete_talk_card)) {
        this.$emit('del', data)
        this.checked = []
      }
    },
    apply (data) {
      this.$emit('apply', data)
    }
  }
}
</script>
